const proxyURL =
  "https://api.bossdrop.ai/handleOpenAImessage";

function loadBrainPrefs() {
  try {
    const raw = localStorage.getItem("bd:brainPrefs");
    const parsed = raw ? JSON.parse(raw) : null;
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

function loadProjectScope() {
  try {
    return localStorage.getItem("bd:projectScope") || "";
  } catch {
    return "";
  }
}

function loadContextFiles() {
  try {
    const raw = localStorage.getItem("bd:aiContextFiles");
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function compactText(value, max = 900) {
  const text = String(value || "").replace(/\s+/g, " ").trim();
  if (!text) return "";
  return text.length <= max ? text : `${text.slice(0, max - 3)}...`;
}

function buildWorkspaceScopedPrompt(message) {
  const projectScope = loadProjectScope();
  const contextFiles = loadContextFiles()
    .slice(0, 6)
    .map((file, idx) => {
      const parts = [
        `${idx + 1}. ${compactText(file?.name || "Context file", 90)}`,
        file?.extractedText
          ? `Contents: ${compactText(file.extractedText, 1600)}`
          : null,
        !file?.extractedText && file?.summary
          ? `Preview: ${compactText(file.summary, 280)}`
          : null,
      ].filter(Boolean);
      return parts.join("\n");
    })
    .filter(Boolean)
    .join("\n\n");

  return [
    projectScope ? `PROJECT_SCOPE:\n${projectScope}` : "",
    contextFiles ? `PROJECT_CONTEXT_FILES:\n${contextFiles}` : "",
    String(message || ""),
  ]
    .filter(Boolean)
    .join("\n\n---\n\n");
}

export const getOpenAIMessage = async (message, signal) => {
  const brainPrefs = loadBrainPrefs();
  const dataIn = {
    data: {
      message: buildWorkspaceScopedPrompt(message),
    },
    opts: {
      provider: brainPrefs?.aiProvider || "claude",
    },
  };
  for (let i = 0; i < 1; i++) {
    try {
      const response = await fetch(proxyURL, {
        method: "POST",
        credentials: "include",
        signal,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataIn),
      });
      return await response.json();
    } catch (err) {
      // Log error
      console.error(`Attempt ${i + 1} failed. Error: ${err}`);
      // If it was the last attempt, throw the error
      if (i + 1 === 1) {
        return "err";
      }
    }
  }
};

export default getOpenAIMessage
